import { Client, CompanyMain, ContactImage } from '../models';
import CreatedContact from '../models/created-contact';
import { isClientDto } from './dtos';
export function isIndividual(contact) {
  if (contact) {
    return isIndividualEntityType(contact.entityType);
  }
  return true;
}
export function isIndividualEntityType(entityType) {
  var entityTypeId = entityType.id.toUpperCase();
  /* spell-checker: disable */
  return entityTypeId === 'USINDIVIDUAL' || entityTypeId === 'CAINDIVIDUAL' || entityTypeId === 'GBINDIVIDUAL' || entityTypeId === 'ARINDIVIDUAL' || entityTypeId === 'AUINDIVIDUAL' || entityTypeId === 'BRINDIVIDUAL' || entityTypeId === 'ININDIVIDUAL' || entityTypeId === 'NLINDIVIDUAL' || entityTypeId === 'ZZINDIVIDUAL';
  /* spell-checker: enable */
}
export function clientDtoToClient(client) {
  var contact = isClientDto(client) ? client.primaryContactExpanded : client.contactView;
  return new Client(client.id, client.name, client.code, contact, isIndividual(contact));
}
export function companyMainDtoToCompanyMain(companyMainDto) {
  var companyClient = {
    code: companyMainDto.companyClient.code,
    contactId: companyMainDto.companyClient.contactId,
    id: companyMainDto.companyClient.id,
    name: companyMainDto.companyClient.name
  };
  return new CompanyMain(companyClient);
}
export function createdContactDtoToCreatedContact(contact) {
  var createdContactConstructorArgs = {
    id: contact.id,
    updated: contact.updated,
    companyId: contact.companyId
  };
  return new CreatedContact(createdContactConstructorArgs);
}
export function contactImageDtoToContactImage(contactImage) {
  return new ContactImage(contactImage.imageData);
}

/* code, entityType.id, and clientContact.nationalIdentityKind.id need to
have valid parameters or core throws an exception.
However, they are unimportant in our context and only
the emailAddress ends up being used in the api call.
So, we fill them out with unrelated but valid parameters */
export function findClientByEmailBody(emailAddress) {
  var requestBody = {
    code: 'code',
    entityType: {
      name: '',
      /* spell-checker: disable-next-line */
      id: 'USUNSPECIFIED'
    },
    clientContact: {
      name: {},
      nationalIdentityKind: {
        id: 'US-SSN',
        name: ''
      },
      emailAddress: emailAddress
    }
  };
  return requestBody;
}
